import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'sales' | 'viewer';
  requireApproval?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  requireApproval = true
}) => {
  const { user, loading, isApproved } = useAuth();

  console.log('ProtectedRoute check:', { loading, user: user?.email, isApproved, requiredRole });

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    console.log('No user, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Check if user is deactivated (explicit false or not defined but not approved)
  const isDeactivated = user.isActive === false;
  if (isDeactivated) {
    console.log('User is deactivated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Check if user needs approval (unless specifically not required)
  if (requireApproval && !isApproved) {
    console.log('User not approved, redirecting to pending-approval');
    return <Navigate to="/pending-approval" replace />;
  }

  if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
    console.log('User does not have required role, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('ProtectedRoute passed, rendering children');
  return <>{children}</>;
};
